module.exports = __webpack_public_path__ + "static/media/bathroom_slippers.fb92af51.svg";